import { MuiTelInput } from "mui-tel-input";
import "./styles.css";

type Props = {
    value: string | undefined;
    onChange: (value: string | undefined) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
};

export default function PhoneInput({ value, onChange, placeholder, disabled, readOnly }: Props) {
    return (
        <MuiTelInput
            className="phone-input"
            defaultCountry="EG"
            forceCallingCode
            value={value ?? ""}
            onChange={(newValue) => onChange(newValue)}
            placeholder={placeholder}
            disabled={disabled}
            slotProps={{ input: { readOnly } }}
        />
    );
}
